<template>
  <span>
    <div class="block-shipping-status" v-if="!textOnly">
      <div class="spinner" v-bind:class="{ loading: (theShipping.status === 'WAITING' || theShipping.status === 'DRAFT' || theShipping.status === 'READYATSTORE' || theShipping.status === 'READY') }">
        <div class="loader">
          <div class="loader">
            <div class="loader">
              <div class="loader">
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="spinner clock" v-bind:class="{ loading: (theShipping.status === 'WAITING' || theShipping.status === 'DRAFT' || theShipping.status === 'READY') && isScheduled }"><font-awesome-icon :icon="['far', 'clock']" size="1x" /></div>
      <div md="12" v-show="theShipping.status === 'DRAFT' && !isScheduled" class="status" v-translate translate-context="statuses">
        Received by the system
      </div>
      <div md="12" v-show="theShipping.status === 'DRAFT' && isScheduled" class="status" translate-context="statuses" v-translate="{scheduledDate: theShipping.scheduled_date ? moment.utc(theShipping.scheduled_date).local().format('L LT') : ''}">
        Shipping created and scheduled for %{scheduledDate}
      </div>
      <div md="12" v-show="theShipping.status === 'WAITING' && !isScheduled" class="status" v-translate="{courierI18n: this.courierI18n}">
        Searching for %{courierI18n}
      </div>
      <div md="12" v-show="theShipping.status === 'READYATSTORE' && !isScheduled" class="status" v-translate translate-context="statuses">
        Ready at store
      </div>
      <div md="12" v-show="theShipping.status === 'READY' && !isScheduled" class="status" v-translate translate-context="statuses">
        Ready to be scheduled
      </div>
      <div md="12" v-show="(theShipping.status === 'WAITING' || theShipping.status === 'READY') && isScheduled" class="status" v-translate="{scheduledDate: theShipping.scheduled_date ? moment.utc(theShipping.scheduled_date).local().format('L LT') : ''}">
        Scheduled for %{scheduledDate}
      </div>
      <div md="12" v-show="theShipping.status === 'CONFIRMED'" class="status" v-translate="{courierI18n: this.courierI18n}">
        %{courierI18n} in transit to origin
      </div>
      <div md="12" v-show="theShipping.status === 'ATPICKUPPOINT'" class="status" v-translate="{courierI18n: this.courierI18n}">
        %{courierI18n} arrived to origin
      </div>
      <div md="12" v-show="theShipping.status === 'INTRANSIT'" class="status" v-translate="{courierI18n: this.courierI18n}">
        %{courierI18n} in transit to destination
      </div>
      <div md="12" v-show="theShipping.status === 'DELIVERED'" class="status" v-translate>
        Shipping delivered! :)
      </div>
      <div md="12" v-show="theShipping.status === 'CANCELED'" class="status" v-translate>
        Shipping canceled! :(
      </div>
      <div md="12" v-show="theShipping.status === 'INCIDENCE'" class="status text-warning" v-translate>
        Shipping on incidence!
      </div>
      <div md="12" v-show="theShipping.status === 'TOBERETURNED'" class="status text-warning" v-translate translate-context="statuses">
        To be returned to sender
      </div>
      <div md="12" v-show="theShipping.status === 'RETURNED'" class="status text-danger" v-translate>
        Returned to sender!
      </div>
      <div v-if="(theShipping.status === 'TOBERETURNED' || theShipping.status === 'INCIDENCE') && theShipping.status_history.length > 0 && theShipping.status_history[0].details" class="text-left my-2">
        <p class="text-dark"><span class="bg-warning">&nbsp;{{statusReasonsStrings[theShipping.status_history[0].details.reason] || theShipping.status_history[0].details.reason}}&nbsp;</span></p>
        <p v-if="visits > 0" class="text-dark"><translate>Visits</translate>: <span class="bg-warning">&nbsp;{{visits}}&nbsp;</span></p>
      </div>
      <div v-if="theShipping.status === 'RETURNED' && theShipping.status_history.length > 0 && theShipping.status_history[0].details" class="text-left my-2">
        <p class="text-dark"><translate>Reason</translate>: <span class="bg-danger text-light">&nbsp;{{theShipping.status_history[0].details.reason}}&nbsp;</span></p>
      </div>
    </div>
    <span v-else>
      <span v-show="theShipping.status === 'DRAFT' && !isScheduled" class="status" v-translate translate-context="statuses">
        Received by the system
      </span>
      <span v-show="theShipping.status === 'DRAFT' && isScheduled" class="status" translate-context="statuses" v-translate="{scheduledDate: theShipping.scheduled_date ? moment.utc(theShipping.scheduled_date).local().format('L LT') : ''}">
        Shipping created and scheduled for %{scheduledDate}
      </span>
      <span v-show="theShipping.status === 'WAITING' && !isScheduled" class="status" v-translate="{courierI18n: this.courierI18n}">
        Searching for %{courierI18n}
      </span>
      <span v-show="theShipping.status === 'READYATSTORE' && !isScheduled" class="status" v-translate translate-context="statuses">
        Ready at store
      </span>
      <span v-show="theShipping.status === 'READY' && !isScheduled" class="status" v-translate translate-context="statuses">
        Ready to be scheduled
      </span>
      <span v-show="(theShipping.status === 'WAITING' || theShipping.status === 'READY') && isScheduled" class="status" v-translate="{scheduledDate: theShipping.scheduled_date ? moment.utc(theShipping.scheduled_date).local().format('L LT') : ''}">
        Scheduled for %{scheduledDate}
      </span>
      <span v-show="theShipping.status === 'CONFIRMED'" class="status" v-translate="{courierI18n: this.courierI18n}">
        %{courierI18n} in transit to origin
      </span>
      <span v-show="theShipping.status === 'ATPICKUPPOINT'" class="status" v-translate="{courierI18n: this.courierI18n}">
        %{courierI18n} arrived to origin
      </span>
      <span v-show="theShipping.status === 'INTRANSIT'" class="status" v-translate="{courierI18n: this.courierI18n}">
        %{courierI18n} in transit to destination
      </span>
      <span v-show="theShipping.status === 'DELIVERED'" class="status" v-translate>
        Shipping delivered! :)
      </span>
      <span v-show="theShipping.status === 'CANCELED'" class="status" v-translate>
        Shipping canceled! :(
      </span>
      <span v-show="theShipping.status === 'INCIDENCE'" class="status text-warning" v-translate>
        Shipping on incidence!
      </span>
      <span v-show="theShipping.status === 'TOBERETURNED'" class="status text-warning" v-translate translate-context="statuses">
        To be returned to sender
      </span>
      <span v-show="theShipping.status === 'RETURNED'" class="status text-danger" v-translate>
        Returned to sender!
      </span>
    </span>
  </span>

</template>

<script>
import constants from '@/common/constants'

export default {
  data() {
    return {
      theShipping: {},
      visits: 0
    }
  },
  props: {
    shipping: {
      type: Object,
      required: true
    },
    textOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isScheduled() {
      return this.theShipping.scheduled_date && this.moment.utc(this.theShipping.scheduled_date) > this.moment().utc()
    }
  },
  watch: {
    shipping: function (val) {
      this.theShipping = val
    }
  },
  mixins: [constants],
  created() {
    this.theShipping = this.shipping
    if (this.theShipping.status === 'INCIDENCE') {
      for (let i = 0; i < this.theShipping.status_history.length; i++) {
        if (this.theShipping.status_history[i].details && (this.theShipping.status_history[i].details.reason === 'absent_recipient' || this.theShipping.status_history[i].details.reason === 'absent_client')) {
          this.visits++
        }
      }
    }
  }
}
</script>
